module.exports = __webpack_public_path__ + "static/img/Paul-McGregor.7e7ddba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Paul-McGregor.jpg
// module id = yt8I
// module chunks = 0